import {Component, OnInit} from "@angular/core";
import {RouteService} from "../../../services/routeService";
import {DICTIONARY} from '../../../dictionary';
import {GeneralService} from "../../../services/generalService";
import {NotificationService} from "../../../services/notificationService";
import * as platform from 'platform';
import util from "util";
import _ from 'lodash';
import {ENV_CONSTS} from "../../../constants";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../../services/authService";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
	selector: 'support-tickets-component',
	templateUrl: './support-tickets.component.html',
})
export class SupportTicketsComponent implements OnInit {

	allTickets;
	getTicketsInProcess;
	newTicketPopup;
	showTicketDetailsPopup;
	dic = DICTIONARY;
	filterData;
	attachmentFiles;
	validDrag;
	invalidDrag;
	_ = _;
	closeTicketPopup;
	supportEmail = 'support@trustificorp.com';
	viewAllPlanUsers = false;

	summernoteConfig = {
		height: 100,
		width: '100%',
		toolbar: [
			['style', ['bold', 'italic', 'underline']],
			['fontsize', ['fontsize']],
			['view', ['codeview']]
		],
		codemirror: {
			theme: 'monokai'
		},
		placeholder: 'Add your reply to the support team'
	};

	constructor(private rs:RouteService,
				public gs:GeneralService,
				public sanitizer:DomSanitizer,
				public authService:AuthService,
				public http:HttpClient,
				private ns:NotificationService) {}

	ngOnInit() {
		this.initFilters();
		this.getTickets();

		if (window.history.state.data === 'open') {
			this.openTicketPopup();
		}
		else if (window.history.state.data?.hasOwnProperty('aiConversation')) {
			this.openTicketPopup(window.history.state.data.aiConversation || [], true);
		}
	}

	getTickets = () => {
		this.getTicketsInProcess = true;

		const params:any = {};
		if (this.viewAllPlanUsers) {
			params.isPlanTickets = true;
		}

		this.rs.getAllTickets(params).then(res => {
			this.allTickets = res || [];
			this.allTickets?.forEach((ticketObj) => {
				this.parseTicketStatus(ticketObj);
			});
			this.getTicketsInProcess = false;
		}, err => {
			this.getTicketsInProcess = false;
		});
	}

	parseTicketStatus = (ticketObj) => {
		switch (ticketObj.status) {
			case 2: // open
			case 7: // Waiting on Partner/Third Party
			case 6: // Waiting on customer
			case 8: // Escalated (Waiting for Tier-2)
			case 9: // Escalated to Security Team
			case 10: // Teams call required/scheduled
			case 13: // Waiting on T2 Fix or Development
			case 14: // In Progress
			case 15: // Reopened
				ticketObj.status = 'Open';
				break;

			case 3:
				ticketObj.status = 'Pending';
				break;

			case 4:
				ticketObj.status = 'Resolved';
				break;

			case 5:
				ticketObj.status = 'Closed';
				break;
		}
	}

	initFilters = () => {
		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.supportTickets,
			filters: {
				status: ['Open', 'Pending', 'Resolved', 'Closed'],
				type: ["Question", "Incident", "Request", "Bug Report", "Email Delays", "Deployment/Onboarding", "Problem", "False Negative / Positive", "Renewal", "Feature Request"],
			},
			initFiltersFunction: this.initFilters,
		};
	}

	openTicketPopup = (conversation=null, isSkipAI=false) => {
		this.newTicketPopup = {
			OSTypes: ['Windows 11', 'Windows 10','Mac','Android','iOS', 'Linux'],
			OSSelectedType: 'Windows 11',

			browsers: ['Chrome', 'Edge','Firefox','Safari','Opera', 'Brave'],
			browserSelected: 'Chrome',

			reason: ["Question", "Incident", "Request", "Bug Report", "Email Delays", "Deployment/Onboarding", "Problem", "False Negative / Positive", "Renewal", "Feature Request"],
			reasonSelected: 'Question',

			severityLevels: ['Low', 'Medium', 'High', 'Critical'],
			severitySelected: 'Low',

			messageText: conversation?.[1]?.message || '',
			aiConversation: conversation?.length ? conversation : null,

			showAI: !(conversation || isSkipAI),
			show: true,
		};

		try {
			const OSSelectedType = platform.os.family.replace('Chromium', '').trim();
			if (OSSelectedType === 'OS X') {
				this.newTicketPopup.OSSelectedType = 'Mac';
			}
			else if (["Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE"].indexOf(OSSelectedType) >= 0) {
				this.newTicketPopup.OSSelectedType = 'Linux';
			}
		} catch (ex) {
			console.error(ex);
		}

		try {
			if (platform.name.includes('Chrome')) {
				this.newTicketPopup.browserSelected = 'Chrome';
			} else if (platform.name.includes('Firefox')) {
				this.newTicketPopup.browserSelected = 'Firefox';
			} else if (platform.name.includes('Safari')) {
				this.newTicketPopup.browserSelected = 'Safari';
			} else if (platform.name.includes('Edge')) {
				this.newTicketPopup.browserSelected = 'Edge';
			}
		} catch (ex) {
			console.error(ex);
		}
	}

	resolvedByAI = () => {
		this.newTicketPopup.aiHelpedLoader = true;

		setTimeout(() => {
			this.newTicketPopup.aiHelpedLoader = false;
			this.ns.showInfoMessage('Thank you for the feedback! We glad our AI assistant could help.');
		}, 1200);
	}

	escalateToTicket = (chatBotEl) => {
		this.newTicketPopup.showAI = false;
		this.newTicketPopup.aiConversation = chatBotEl.conversation;
		this.newTicketPopup.messageText = this.newTicketPopup.aiConversation?.[1]?.message;
		this.newTicketPopup.reasonSelected = 'Problem';
		this.newTicketPopup.severitySelected = 'Medium';
	}

	validateTicketInfo = () => {
		if (this.newTicketPopup.inProcess) {
			return;
		}
		this.newTicketPopup.supportTicketTextErr = false;

		// validations:
		if (!this.newTicketPopup.messageText) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Message text'));
			this.newTicketPopup.supportTicketTextErr = true;
			return;
		}

		this.newTicketPopup.supportTicketTitleTextErr = false;
		if (!this.newTicketPopup.messageTitle) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Title'));
			this.newTicketPopup.supportTicketTitleTextErr = true;
			return;
		}

		// CC: up to 2 addresses; the backend also enforces that they belong to a verified plan domain
		this.newTicketPopup.ccInputError = false;
		this.newTicketPopup.ccEmails = (this.newTicketPopup.ccInput || '').split(/[,;\s]+/).filter(email => email);
		if (this.newTicketPopup.ccEmails.length > 2) {
			this.ns.showWarnMessage(this.dic.ERRORS.maxTicketCcEmails);
			this.newTicketPopup.ccInputError = true;
			return;
		}
		if (this.newTicketPopup.ccEmails.some(email => !this.gs.validateEmail(email))) {
			this.ns.showWarnMessage(this.dic.ERRORS.oneOfEmailsInvalid);
			this.newTicketPopup.ccInputError = true;
			return;
		}

		return true;
	}

	openTicketExecute = () => {
		if (!this.validateTicketInfo()) {
			return;
		}

		const ticketInfo:any = {
			title: this.newTicketPopup.messageTitle,
			type: this.newTicketPopup.reasonSelected,
			message: this.newTicketPopup.messageText,
			OS: this.newTicketPopup.OSSelectedType,
			browser: this.newTicketPopup.browserSelected,
			severity: this.newTicketPopup.severitySelected
		};

		// add previous AI conversation to ticket description
		if (this.newTicketPopup.aiConversation?.length > 2) {
			ticketInfo.chatHistory = '';
			this.newTicketPopup.aiConversation.forEach((message, index) => {
				if (index > 0) {
					ticketInfo.chatHistory += `${message.role === 'user' ? 'User:<br/>' : 'AI:'} ${message.message}${message.role === 'user' ? '<br/><br/>' : '<br/>'}`;
				}
			});
		}
		//

		const formData = new FormData();
		// parameters
		for (const [key, value] of Object.entries(ticketInfo) as any) {
			formData.append(key, value);
		}
		if (this.attachmentFiles?.length) {
			this.attachmentFiles.forEach((file) => {
				formData.append('attachment[]', file);
			});
		}
		this.newTicketPopup.ccEmails.forEach((email) => {
			formData.append('cc[]', email);
		});
		//

		this.newTicketPopup.inProcess = true;

		this.http.post(ENV_CONSTS.attachmentUrl + '/user/tickets', formData, {headers: this.authService.getHeaders()})
			.subscribe(event => {
				this.getTickets();
				this.attachmentFiles = null;
				this.newTicketPopup = null;
				this.ns.showInfoMessage('Ticket opened successfully');
			}, (errEvent) => {
				this.newTicketPopup.inProcess = false;
				this.ns.showErrorMessage(errEvent.error.message);
			});
	};


	getTicketData(ticketObj) {
		ticketObj.selected = !ticketObj.selected;

		this.showTicketDetailsPopup = {
			show: true,
			ticketObj: ticketObj,
			inProcess: true,
			attachmentFiles: null,
			text: ''
		};
		ticketObj.getTicketDataInProcess = true;

		const params:any = {};
		if (this.viewAllPlanUsers) {
			params.isPlanTickets = true;
		}

		this.rs.getTicketData(ticketObj.id.toString(), params).then(res => {
			res.conversations.push(_.pick(res, 'from_email', 'attachments', 'created_at', 'description' ,'subject'));
			this.showTicketDetailsPopup.info = res;
			this.showTicketDetailsPopup.inProcess = false;
		}, err => {
			this.showTicketDetailsPopup.inProcess = false;
		});
	}

	addUserReply = (ticketObj) => {
		if (this.showTicketDetailsPopup.replyInProcess || this.viewAllPlanUsers) {
			return;
		}

		if (!this.showTicketDetailsPopup.text) {
			this.ns.showErrorMessage('Missing reply text');
			return;
		}

		const actionInfo:any = {
			action: 'reply',
			text: this.showTicketDetailsPopup.text,
		};

		const formData = new FormData();
		// parameters
		for (const [key, value] of Object.entries(actionInfo) as any) {
			formData.append(key, value);
		}
		if (this.showTicketDetailsPopup.attachmentFiles?.length) {
			this.showTicketDetailsPopup.attachmentFiles.forEach((file) => {
				formData.append('attachment[]', file);
			});
		}
		//

		this.showTicketDetailsPopup.replyInProcess = true;

		this.http.put(ENV_CONSTS.attachmentUrl + '/user/tickets/' + ticketObj.id.toString(), formData, {headers: this.authService.getHeaders()})
			.subscribe(event => {
				this.ns.showInfoMessage('Ticket replied successfully');
				this.showTicketDetailsPopup.attachmentFiles = null;
				this.showTicketDetailsPopup.replyInProcess = false;
				this.getTicketData(ticketObj);
			}, (errEvent) => {
				this.showTicketDetailsPopup.replyInProcess = false;
				this.ns.showErrorMessage(errEvent.error.message);
			});
	}

	closeTicket(tickets) {
		if (this.viewAllPlanUsers) {
			return;
		}

		this.closeTicketPopup = {
			show: true,
			tickets: tickets,
			title: tickets?.length === 1 ? 'Close Ticket' : 'Close Tickets',
			inProcess: false,
			doneCb: () => {
				if (this.closeTicketPopup.inProcess) return;
				this.closeTicketPopup.inProcess = true;
				tickets.forEach(ticketObj => {
					if (ticketObj.status === 'Closed') return;
					const actionInfo = {
						action: 'close',
						rating: this.closeTicketPopup.satisfaction,
						feedback: this.closeTicketPopup.feedback
					};
					this.rs.updateTicket(ticketObj.id.toString(), actionInfo).then(res => {
						this.ns.showInfoMessage('Ticket closed successfully');
						ticketObj.status = 5;
						this.parseTicketStatus(ticketObj)
					}, err => {
					});
				});
				this.closeTicketPopup = null;
			}
		}
	}

	deleteTicket(tickets) {
		if (this.viewAllPlanUsers) {
			return;
		}

		const subTitle = tickets?.length === 1 ? 'Confirm to delete this ticket' : `Confirm to delete ${tickets.length} tickets`;
		this.gs.showPopup({
			title: 'Delete Ticket',
			subTitle: subTitle,
			body: ['Note: after a ticket has been deleted, you can no longer view it or take actions on it.'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				tickets.forEach(ticketObj => {
					this.rs.deleteTicket(ticketObj.id.toString()).then(res => {
						this.ns.showInfoMessage('Ticket deleted successfully');
						this.getTickets();
					}, err => {
					});
				});

			}
		});
	}

	selectTicketAction = (ticketObj, action) => {
		switch (action) {
			case 'Delete':
				this.deleteTicket([ticketObj]);
				break;

			case 'Close':
				this.closeTicket([ticketObj]);
				break;

			case 'Info':
				this.getTicketData(ticketObj);
				break;
		}
	}

	showTicketActions = (ticketObj) => {
		if (this.viewAllPlanUsers) {
			return ['Info'];
		}
		if (ticketObj.status === 'Closed' || ticketObj.status === 'Resolved') {
			return ['Info', 'Delete'];
		}
		return ['Info', 'Close', 'Delete'];
	}

	showTicketBulkActions = () => {
		if (this.viewAllPlanUsers) {
			return [];
		}
		return ['Close', 'Delete'];
	}

	selectTicketBulkAction = (tickets, action) => {
		switch (action) {
			case 'Delete':
				this.deleteTicket(tickets);
				break;

			case 'Close':
				this.closeTicket(tickets);
				break;
		}
	}

	searchTicket = (event) => {
		this.allTickets.forEach(record => {
			// search
			if (event.searchTerm) {
				const isFound = searchTextExecute(record, event.searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			if (event.activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(event.activeFilters).length;

				if (event.activeFilters.status?.length) {
					if (event.activeFilters.status.includes(record.status)) {
						numFilterToMatch--;
					}
				}

				if (event.activeFilters.type?.length) {
					if (event.activeFilters.type.includes(record.type)) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}


			record.hide = false;
		});
	};

	openMessageAttachment(name, url) {
		const a = document.createElement('a');
		a.href = url;
		a.target = '_blank';
		a.download = name;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	// BUG FIX : ngfDrop must be overriding the "dragover" event listener of summernote. so we handle it manually
	toggleSummernoteDragState = (setState, event) => {
		const summernoteContainer = document.getElementById('summernoteContainer');

		if (setState && event.target.className === 'note-editable') {
			summernoteContainer.classList.add('summernote-hovered');
		}

			// (a new layer is now inserted because of the last class change so the "drag" event now passes to this new layer)
		// in case of a drag leave without dropping
		else if (!setState && (event.target.className === 'note-dropzone-message')) {
			summernoteContainer.classList.remove('summernote-hovered');
		}
	}
	//

	validateFiles = (attachmentList) => {
		if (!attachmentList?.length) {
			return;
		}

		// 20MB limit (due to the API's limit)
		if (_.sumBy(attachmentList, 'size') > 20970000) {
			this.ns.showErrorMessage(util.format(this.dic.ERRORS.filesMaxSizeX, '20MB'));

			while (_.sumBy(attachmentList, 'size') > 20970000) {
				// remove last file from attachment list
				try {
					attachmentList.pop();
				}
				catch (err) {
					console.error(err);
				}
			}
		}
	}

	removeFromAttachments = (list, attachment) => {
		list.splice(_.indexOf(list, attachment), 1);
	}

}


function searchTextExecute(ticketObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();

	return ((ticketObj.subject?.toLowerCase().indexOf(searchTerm) > -1) ||
		(ticketObj.type?.toLowerCase().indexOf(searchTerm) > -1) ||
		(ticketObj.status?.toLowerCase().indexOf(searchTerm) > -1) ||
		(ticketObj.custom_fields?.cf_requester_email?.toLowerCase().indexOf(searchTerm) > -1) ||
		(ticketObj.description?.toLowerCase().indexOf(searchTerm) > -1));
}
